import { WidgetError } from "./widget-error.js";

/**
 * @class
 * @classdesc Represents an unhandled runtime error in the current flow
 * @augments WidgetError
 */
export class WidgetRuntimeError extends WidgetError {

    /**
     * @param {object} rawError Error coming from Davinci
     * @constructor
     */
    constructor(rawError = {}) {
        super("WidgetRuntimeError", `Widget ran into a runtime error: ${rawError.message || "Unknown cause"}`, rawError);
    }
}